import React, { createContext, useState } from "react";

interface EditAssignationActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;  
}

export const EditAssignationActionContext = createContext<EditAssignationActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},  
});

interface EditAssignationActionProviderProps {
  children: React.ReactNode;
}

export const EditAssignationActionProvider: React.FC<EditAssignationActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);  

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    showModal,
    setShowModal,
    element,
    setElement,    
  };
  return (
    <EditAssignationActionContext.Provider value={value}>      
      {children}
    </EditAssignationActionContext.Provider>
  );
};
